import { Loader2, RefreshCw, Library, Home, History as HistoryIcon } from "lucide-react";
import { DiscoLogo } from "./DiscoLogo";
import { coverUrl } from "../lib/api";
import { getMoodMeta } from "../lib/moods";

export default function Sidebar({ library, syncing, onSync, history, onOpen, onNav }) {
  return (
    <aside className="hidden md:flex w-[280px] shrink-0 flex-col gap-2">
      <div className="bg-[#121212] rounded-lg p-5 flex flex-col gap-5">
        <div className="flex items-center gap-2">
          <DiscoLogo size={34} />
          <span className="font-extrabold text-lg tracking-tight">Glimpse</span>
        </div>
        <button data-testid="nav-home" onClick={() => onNav("top-anchor")} className="flex items-center gap-4 font-bold text-white">
          <Home className="h-6 w-6" /> Accueil
        </button>
        <button data-testid="nav-history" onClick={() => onNav("history-anchor")} className="flex items-center gap-4 font-bold text-[#B3B3B3] hover:text-white transition-colors">
          <HistoryIcon className="h-6 w-6" /> Historique
        </button>
      </div>
      <div className="bg-[#121212] rounded-lg p-4 flex-1 flex flex-col gap-3 overflow-y-auto">
        <span className="flex items-center gap-3 font-bold text-[#B3B3B3]"><Library className="h-6 w-6" /> Ma bibliothèque</span>
        <div className="bg-[#242424] rounded-lg p-4">
          <div className="font-bold text-white text-sm">
            {library.count > 0 ? `${library.count} titres synchronisés` : "Synchronise ta bibliothèque"}
          </div>
          <div className="text-xs text-[#B3B3B3] mt-1">Playlists perso + titres likés</div>
          <button
            data-testid="sync-library-btn"
            onClick={onSync}
            disabled={syncing}
            className="mt-4 rounded-full bg-white text-black font-bold text-sm px-4 py-1.5 hover:scale-105 transition-transform inline-flex items-center gap-2"
          >
            {syncing ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
            {library.count > 0 ? "Resynchroniser" : "Synchroniser"}
          </button>
        </div>
        {history.slice(0, 8).map((g) => (
          <button
            key={g.id}
            data-testid={`sidebar-history-item-${g.id}`}
            onClick={() => onOpen(g)}
            className="flex items-center gap-3 p-2 rounded-md hover:bg-[#1a1a1a] text-left"
          >
            <img src={coverUrl(g.id, g.cover_style)} alt="" loading="lazy" className="h-12 w-12 rounded object-cover shrink-0" />
            <div className="min-w-0">
              <div className="text-white text-sm font-semibold truncate">{getMoodMeta(g).name}</div>
              <div className="text-xs text-[#B3B3B3] truncate">Playlist · {g.duration_minutes}min</div>
            </div>
          </button>
        ))}
      </div>
    </aside>
  );
}
